import { Link } from "react-router-dom";

export const ToolkitCard = () => (
  <section className="relative" data-testid="toolkit-card-section">
    <div className="gutter pb-20 sm:pb-28">
      <div className="lux-card relative mx-auto max-w-3xl overflow-hidden !border-[var(--gold)] px-6 py-12 text-center shadow-[0_0_60px_-12px_rgba(232,184,74,0.45)] sm:px-12 sm:py-14" data-testid="toolkit-card">
        <p className="font-mono-plex text-[12px] tracking-[0.28em] text-[var(--gold)]">STILL AVAILABLE</p>
        <h2 className="chrome-text mt-4 text-4xl sm:text-5xl">The Weaponized Credit Toolkit</h2>
        <p className="mx-auto mt-5 max-w-lg text-[16px] leading-relaxed text-[#cfc7b6]">Walk into class with the checklist and sequences already in hand.</p>
        <Link to="/bridge#toolkit" className="btn-gold mt-8 w-full px-7 py-3.5 text-sm sm:w-auto" data-testid="get-toolkit-button">
          <span>Get the Toolkit →</span>
        </Link>
      </div>
    </div>
  </section>
);
